
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  console.error("Failed to find the root element");
} else {
  try {
    const root = createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } catch (error: any) {
    console.error("Initial render failed:", error);
    if (rootElement) {
      rootElement.innerHTML = `<div style="padding: 20px; color: white; background: #900;">Error: ${error.message}</div>`;
    }
  }
}
